const META_PIXEL_SCRIPT_ID = "meta-pixel-script";

function pixelId(): string {
  return (process.env.REACT_APP_META_PIXEL_ID || "").trim();
}

class MetaPixelService {
  private initialized = false;

  enable() {
    if (typeof window === "undefined" || !pixelId()) return;
    this.bootstrap();
    this.initialized = true;
  }

  disable() {
    if (typeof window === "undefined") return;
    this.initialized = false;

    const existingScript = document.getElementById(META_PIXEL_SCRIPT_ID);
    if (existingScript?.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }

    delete window.fbq;
    delete window._fbq;
  }

  setUser(email: string | null, externalId: string | null) {
    const id = pixelId();
    if (!this.initialized || !window.fbq || !id) return;
    const userData: Record<string, string> = {};
    const normalisedEmail = email?.trim().toLowerCase();
    if (normalisedEmail) userData.em = normalisedEmail;
    if (externalId) userData.external_id = externalId;
    if (Object.keys(userData).length === 0) return;
    window.fbq("init", id, userData);
  }

  track(eventName: string, params?: Record<string, unknown>, eventId?: string) {
    if (!this.initialized || typeof window === "undefined" || !window.fbq) return;
    if (eventId) {
      window.fbq("track", eventName, params ?? {}, { eventID: eventId });
      return;
    }
    if (params) {
      window.fbq("track", eventName, params);
      return;
    }
    window.fbq("track", eventName);
  }

  private bootstrap() {
    const id = pixelId();
    if (!id || window.fbq) return;

    const fbq = function (this: unknown, ...args: unknown[]) {
      const queue = fbq as typeof fbq & {
        callMethod?: (...methodArgs: unknown[]) => void;
        queue: unknown[][];
      };
      if (queue.callMethod) {
        queue.callMethod.apply(queue, args);
      } else {
        queue.queue.push(args);
      }
    } as ((...args: unknown[]) => void) & {
      callMethod?: (...methodArgs: unknown[]) => void;
      queue: unknown[][];
      push: (...args: unknown[]) => void;
      loaded: boolean;
      version: string;
    };

    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;

    const script = document.createElement("script");
    script.id = META_PIXEL_SCRIPT_ID;
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    fbq("init", id);
  }
}

export const metaPixelService = new MetaPixelService();
